<template>
  <div>
    <loader :loading="loading"/>
    <div class="l-row">
      <form-group :label="$t('mercadoLivre.account.label')" :columns="6" :required="true" v-if="mercadoLivreAccounts.length">
        <select v-model="filters.account" class="form-select">
          <option :value=null>{{ $t('choose.label') }}</option>
          <option v-for="account in mercadoLivreAccounts" :value="account.identifier">{{ `${account.name} (${account.nickname})` }}</option>
        </select>
      </form-group>

      <form-group label="Status do anúncio" :columns="6">
        <select v-model="filters.statusAnnouncement" class="form-select">
          <option :value=null>{{ $t('choose.label') }}</option>
          <option value="active">Ativo</option>
          <option value="paused">Pausado</option>
        </select>
      </form-group>
    </div>
  </div>
</template>

<script>
  import { mapActions } from 'vuex'
  import { mapFields } from 'vuex-map-fields'
  import Loader from '@/components/template/Loader'
  import FormGroup from '@/components/template/FormGroup'

  export default {
    data: () => ({
      loading: false,
      filters: {
        account: null,
        statusAnnouncement: null
      }
    }),
    props: {
      module: {
        type: Object,
        required: true
      }
    },
    mounted () {
      if (!this.mercadoLivreAccounts.length) {
        this.loading = true
        this.fetchAccounts({
          options: {
            active: true
          }
        }).then(() => {
          this.loading = false
        })
      }
    },
    methods: {
      ...mapActions('mercadoLivreAccounts', [
        'fetchAccounts'
      ])
    },
    computed: {
      ...mapFields({
        mercadoLivreAccounts: 'mercadoLivreAccounts.accounts'
      })
    },
    components: {
      FormGroup,
      Loader
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// MercadoLivre.vue?7791b2ea